import React from 'react';
import { observer } from 'mobx-react-lite';

import Popup from './popup';

import popupStore from 'src/stores/popup-store';

const Popups = observer(() => {
  const { activePopup } = popupStore;

  const renderPopups = () => {
    if (!activePopup) {
      return null;
    }

    return <Popup popupName={activePopup} />;
  };

  return <>{renderPopups()}</>;
});

export default Popups;
